"use strict";
/**
 * Contratos de dados trafegados pela API REST.
 *
 * Regra de ouro: estes tipos descrevem apenas o que é **seguro expor**.
 * Nada de hash de senha, tokens, IDs internos sequenciais ou vínculo
 * avaliador↔avaliado. Datas trafegam como ISO-8601 string.
 */
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=domain.js.map